import { Modal } from '@mui/material'
import type { Definition, Organization } from '../../../types'
import RedLine from '../images/red-squiggly-line-mobile.svg'
import closeIcon from '../images/close-icon-mobile.svg'
import globeIcon from '../images/globe-icon.svg'
import emailIcon from '../images/email-icon.svg'
import ModalChipRow from './ModalChipRow'
import {
  STRATEGY_PARENT_OPTIONS,
  TARGET_PARENT_OPTIONS,
} from '../../../constants'

interface DetailsModalMobileProps {
  organization: Organization
  definitions: Definition[]
  onCloseModal: () => void
}

const DetailsModalMobile = ({
  organization,
  definitions,
  onCloseModal,
}: DetailsModalMobileProps) => {
  const {
    geo_scope,
    focus,
    strategy,
    target,
    stage,
    repair,
    initiative_type,
    budget_amount,
    budget_date,
    value_amount,
    value_date,
  } = organization
  const isInitiative = organization.initCommTask === true

  return (
    <Modal
      open
      onClose={onCloseModal}
      aria-labelledby="organization-details-mobile"
      aria-describedby="a mobile detailed view of an organization"
    >
      <div
        className="absolute w-[369px] top-[50%] left-[50%] pt-16 border-black translate-x-[-50%] translate-y-[-50%] bg-details-modal-bg-mobile bg-cover focus-visible:outline-none bg-bottom flex flex-col"
        style={{
          maxHeight: `min(calc(100dvh - 32px), 826px)`,
        }}
      >
        <img
          src={closeIcon}
          alt="the letter x"
          role="button"
          className="absolute top-0 right-0 cursor-pointer m-6"
          onClick={onCloseModal}
        />
        <div className="gap-8 flex flex-col flex-1 min-h-0 overflow-y-scroll px-8 bg-transparent pb-4">
          <h2 className="text-[26px] font-decimal font-bold text-green">
            {organization.org_name}
          </h2>
          <div className="flex flex-col gap-2">
            {!isInitiative ? (
              <>
                <ModalChipRow
                  title="Geo Scope"
                  labels={(geo_scope || []).map(
                    (opt) =>
                      definitions.find((def) => {
                        return `geo_scope:${opt}` === def.id
                      })?.display_label || ''
                  )}
                  definitions={definitions}
                />
                <ModalChipRow
                  title="Focus Area"
                  labels={(focus || []).map(
                    (opt) =>
                      definitions.find((def) => {
                        return `focus:${opt}` === def.id
                      })?.display_label || ''
                  )}
                  definitions={definitions}
                />
                <ModalChipRow
                  title="Strategy"
                  labels={(strategy || [])
                    .filter((opt) => {
                      return !STRATEGY_PARENT_OPTIONS.includes(
                        `strategy:${opt}`
                      )
                    })
                    .map(
                      (opt) =>
                        definitions.find((def) => {
                          return `strategy:${opt}` === def.id
                        })?.display_label || ''
                    )}
                  definitions={definitions}
                />
                <ModalChipRow
                  wrap
                  title="Liable Institution"
                  labels={(target || [])
                    .filter((opt) => {
                      return !TARGET_PARENT_OPTIONS.includes(`target:${opt}`)
                    })
                    .map(
                      (opt) =>
                        definitions.find((def) => {
                          return `target:${opt}` === def.id
                        })?.display_label || ''
                    )}
                  definitions={definitions}
                />
              </>
            ) : (
              <>
                <ModalChipRow
                  title="Geo Scope"
                  labels={(geo_scope || []).map(
                    (opt) =>
                      definitions.find((def) => {
                        return `geo_scope:${opt}` === def.id
                      })?.display_label || ''
                  )}
                  definitions={definitions}
                />
                <ModalChipRow
                  title="Stage"
                  labels={(stage || []).map(
                    (opt) =>
                      definitions.find((def) => {
                        return `stage:${opt}` === def.id
                      })?.display_label || ''
                  )}
                  definitions={definitions}
                />
                <ModalChipRow
                  wrap
                  title="Form of Repair"
                  labels={(repair || []).map(
                    (opt) =>
                      definitions.find((def) => {
                        return `repair:${opt}` === def.id
                      })?.display_label || ''
                  )}
                  definitions={definitions}
                />
                <ModalChipRow
                  wrap
                  title="Type of Initiative"
                  labels={(initiative_type || []).map(
                    (opt) =>
                      definitions.find((def) => {
                        return `initiative_type:${opt}` === def.id
                      })?.display_label || ''
                  )}
                  definitions={definitions}
                />
                <div className="flex items-start gap-6">
                  <p
                    className={
                      'uppercase text-[12px] font-decimal min-w-[100px] max-w-[100px]'
                    }
                  >
                    Budget Allocated
                  </p>
                  <p className="text-[12px] font-semibold">
                    {budget_amount} <span className="font-normal">as of</span>{' '}
                    {budget_date}
                  </p>
                </div>

                <div className="flex items-start gap-6">
                  <p
                    className={
                      'uppercase text-[12px] font-decimal min-w-[100px] max-w-[100px]'
                    }
                  >
                    Disbursement
                  </p>
                  <p className="text-[12px] font-semibold">
                    {value_amount} <span className="font-normal">as of</span>{' '}
                    {value_date}
                  </p>
                </div>
              </>
            )}
          </div>
          {organization.org_about && (
            <p className="font-decimal text-[14px] text-black">
              {organization.org_about}
            </p>
          )}
        </div>
        <div className="flex flex-col gap-4 w-full py-6 px-8 bg-white">
          <img
            src={RedLine}
            alt="Red squiggly line"
            className="w-[90px] h-[12px]"
          />
          <p className="font-decimal text-[14px] text-black uppercase mb-4">
            {`${organization.city}, ${organization.state}`}
          </p>
          <div className="flex justify-between">
            <a href={organization.website} target="_blank" rel="noreferrer">
              <img src={globeIcon} alt="globe" />
            </a>
            <div />
            {/* <a href={`mailto:${organization.email}`}>
              <img src={emailIcon} alt="email" />
            </a> */}
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default DetailsModalMobile
